import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import { Label } from "../form";
import FormHeader from "../FormHeader";
import { LISTING_RATINGS } from "../../constants";

function ListingUnitInfos(props) {
  const { property, propertyLeaseSettings, unit, unitLeaseSettings, listing } = props;
  let isLaundry = false;
  if (unit?.laundry || property?.laundry) {
    if (unit?.laundry === "ON_SITE" || unit?.laundry === "IN_UNIT") {
      isLaundry = true;
    }
    if (property?.laundry === "ON_SITE" || property?.laundry === "IN_UNIT") {
      isLaundry = true;
    }
  }

  const getListStrings = (key) => {
    if (!key) return "";
    if (unit && unit[key] && unit[key].length > 0) {
      return unit[key].join(", ").toLowerCase().replaceAll("_", " ");
    }
    return property[key].join(", ").toLowerCase().replaceAll("_", " ");
  };

  return (
    <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
      <FormHeader
        title="Summary"
        description="Tenant screening required and provided by rentbeets"
      />
      <Typography variant="h6" component="h3" gutterBottom>
        Lease Settings
      </Typography>
      <Grid container>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Lease</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.leaseRenewal.join(",")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Number of Days Guest Allowed</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.daysGuestsAllowed}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Subletting Available</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.sublettingAvailable ? 'yes' : 'no'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Proof of Rental Insurance Required</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.proofOfRentalInsurance ? 'yes' : 'no'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Tenant Screening</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.tenantScreening ? 'yes' : 'no'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Credit Check</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.creditCheck ? 'yes' : 'no'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Quiet Hours</Label>
          <Typography gutterBottom variant="p" component="div">
            {propertyLeaseSettings?.quietHours.startLocalTime.replace(
              ":00.000",
              ""
            )}{" "}
            -
            {propertyLeaseSettings?.quietHours.endLocalTime.replace(
              ":00.000",
              ""
            )}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h6" component="h3" gutterBottom>
        Unit
      </Typography>
      <Grid container>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Unit Number</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.number}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Floor Level</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.floorLevel}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Bedrooms</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.numberOfBedrooms}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Number of Rooms</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.numberOfOtherRooms}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Bathroom</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.numberOfBathrooms}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Parking Spot</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.numberOfParkingSpots}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Section 8</Label>
          <Typography gutterBottom variant="p" component="div">
            {unit.section8Approved ? "Yes" : "No"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Laundry</Label>
          <Typography gutterBottom variant="p" component="div">
            {isLaundry && "Yes"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Utilities and Services Included</Label>
          <Typography gutterBottom variant="p" component="div">
            {getListStrings("utilities")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Appliances</Label>
          <Typography gutterBottom variant="p" component="div">
            {getListStrings("appliances")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Safety</Label>
          <Typography gutterBottom variant="p" component="div">
            {getListStrings("safety")}
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="h6" component="h3" gutterBottom>
        Listing Lease Settings
      </Typography>
      <Grid container>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Availability Date</Label>
          <Typography gutterBottom variant="p" component="div">
            {unitLeaseSettings?.availabilityDate || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Additional Pets</Label>
          <Typography gutterBottom variant="p" component="div">
            {unitLeaseSettings?.pets}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Rate</Label>
          <Typography gutterBottom variant="p" component="div">
            {(unitLeaseSettings?.rate.amount &&
              `${unitLeaseSettings?.rate.amount} ${unitLeaseSettings?.rate.currency}`) ||
              "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Late Fee Amount</Label>
          <Typography gutterBottom variant="p" component="div">
            {(unitLeaseSettings?.lateFee.amount &&
              `${unitLeaseSettings?.lateFee.amount} ${unitLeaseSettings?.lateFee.currency}`) ||
              "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2} mb={2}>
          <Label>Security Deposit</Label>
          <Typography gutterBottom variant="p" component="div">
            {(unitLeaseSettings?.securityDeposit.amount &&
              `${unitLeaseSettings?.securityDeposit.amount} ${unitLeaseSettings?.securityDeposit.currency}`) ||
              "-"}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={2} mb={2}>
          <Label>Addendums</Label>
          <Typography gutterBottom variant="p" component="div">
            {(unitLeaseSettings.addendums &&
              unitLeaseSettings.addendums.join(", ")) ||
              "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label>Additonal Information</Label>
          <Typography gutterBottom variant="p" component="div">
            {property?.additionalInformationMarkdown || "-"}
          </Typography>
        </Grid>
      </Grid>
      <br/><br/>
      {listing?.ratings && <>
        <FormHeader
          title="Ratings"
        />
        <Grid container>
          {LISTING_RATINGS.map((listingRating, index) => 
            <Grid item xs={12} lg={12}>
              <Grid container>
                <Grid item xs={12} md={4} lg={4}>{listingRating?.label}</Grid>
                <Grid item xs={12} md={8} lg={8}><Rating name="" value={listing?.ratings[listingRating?.name]} readOnly /></Grid>
              </Grid>
              <hr/>
            </Grid>
          )}
        </Grid>
      </>}
    </Paper>
  );
}

export default ListingUnitInfos;
